
var ccNumberInput = null,
    ccNumberPattern = /^\d{0,16}$/g,
    ccNumberSeparator = " ",
    ccNumberInputOldValue,
    ccNumberInputOldCursor;

var ccExpiryInput = null,
    ccExpiryPattern = /^\d{0,4}$/g,
    ccExpirySeparator = "/",
    ccExpiryInputOldValue,
    ccExpiryInputOldCursor;

var ccCVCInput = null,
    ccCVCPattern = /^\d{0,3}$/g;

var payButton = null;

var dotnetHelper = null;

function mask(value, limit, separator) {
    var output = [];
    for (var i = 0; i < value.length; i++) {
        if (i !== 0 && i % limit === 0) {
            output.push(separator);
        }

        output.push(value[i]);
    }

    return output.join("");
}

function unmask(value) {
    return value.replace(/[^\d]/g, '');
}

function checkSeparator(position, interval) {
    return Math.floor(position / (interval + 1));
}

function ccNumberInputKeyDownHandler(e) {
    var el = e.target;
    ccNumberInputOldValue = el.value;
    ccNumberInputOldCursor = el.selectionEnd;
}

function ccNumberInputInputHandler(e) {
    var el = e.target,
        newValue = unmask(el.value),
        newCursorPosition;

    if (newValue.match(ccNumberPattern)) {
        newValue = mask(newValue, 4, ccNumberSeparator);

        newCursorPosition =
            ccNumberInputOldCursor - checkSeparator(ccNumberInputOldCursor, 4) +
            checkSeparator(ccNumberInputOldCursor + (newValue.length - ccNumberInputOldValue.length), 4) +
            (unmask(newValue).length - unmask(ccNumberInputOldValue).length);

        el.value = (newValue !== "") ? newValue : "";
    } else {
        el.value = ccNumberInputOldValue;
        newCursorPosition = ccNumberInputOldCursor;
    }

    el.setSelectionRange(newCursorPosition, newCursorPosition);

    highlightCC(el.value);
}

function highlightCC(ccValue) {
    var ccCardType = '',
        ccCardTypePatterns = {
            amex: /^3/,
            visa: /^4/,
            mastercard: /^5/,
            disc: /^6/,
            genric: /(^1|^2|^7|^8|^9|^0)/,
        };

    for (var cardType in ccCardTypePatterns) {
        if (ccCardTypePatterns[cardType].test(ccValue)) {
            ccCardType = cardType;
            break;
        }
    }

    var activeCC = document.querySelector('.cc-types__img--active'),
        newActiveCC = document.querySelector('.cc-types__img--' + ccCardType);

    if (activeCC) activeCC.classList.remove('cc-types__img--active');
    if (newActiveCC) newActiveCC.classList.add('cc-types__img--active');
}

function ccExpiryInputKeyDownHandler(e) {
    var el = e.target;
    ccExpiryInputOldValue = el.value;
    ccExpiryInputOldCursor = el.selectionEnd;
}

function ccExpiryInputInputHandler(e) {
    var el = e.target, newValue = el.value;

    newValue = unmask(newValue);
    if (newValue.match(ccExpiryPattern)) {
        newValue = mask(newValue, 2, ccExpirySeparator);
        el.value = newValue;
    } else {
        el.value = ccExpiryInputOldValue;
    }

    var dataArray = newValue.split('/');
    var month = dataArray[0];
    var year = dataArray.length > 1 ? dataArray[1] : '';

    var realMonth = document.getElementById('card-expiry-month');
    var realYear = document.getElementById('card-expiry-year');
    realMonth.value = month;
    realYear.value = year;
}

function ccCVCInputHandler(e) {
    var el = e.target;
    var newValue = el.value;

    newValue = unmask(newValue);
    if (newValue.match(ccCVCPattern)) {
        el.value = newValue;
    }
}

function executePayment() {
    hidePaymentError();
    event.preventDefault();
    payButton.disabled = true;
    showHidePaymentButtonSpinner(true);
    var form = document.getElementById('card-form');
    Conekta.Token.create(form, conektaSuccessResponseHandler, conektaErrorResponseHandler);
}

function conektaSuccessResponseHandler(token) {
    dotnetHelper.invokeMethodAsync('ExecutePayment', token.id);
}

function conektaErrorResponseHandler(response) {
    var error = response.message_to_purchaser;
    payButton.disabled = false;
    showHidePaymentButtonSpinner(false);
    setAndShowError(error);
}

function hidePaymentError() {
    var errorContainer = document.getElementById('payment-error-container');
    errorContainer.style.display = 'none';
}

function setAndShowError(errorText) {
    var errorDiv = document.getElementById('payment-error');
    errorDiv.innerHTML = errorText;
    var errorContainer = document.getElementById('payment-error-container');
    errorContainer.style.display = 'block';
    payButton.disabled = false;
    showHidePaymentButtonSpinner(false);
}

function showHidePaymentButtonSpinner(show) {
    var spinner = document.getElementById('payment-button-spinner');
    if (show) spinner.style.display = 'inline-block';
    else spinner.style.display = 'none';
}

function initCardMasks(dotNetObject) {
    dotnetHelper = dotNetObject;

    ccNumberInput = document.getElementById('card-number');
    ccNumberInput.addEventListener('keydown', ccNumberInputKeyDownHandler);
    ccNumberInput.addEventListener('input', ccNumberInputInputHandler);

    ccExpiryInput = document.getElementById('card-expiry-date');
    ccExpiryInput.addEventListener('keydown', ccExpiryInputKeyDownHandler);
    ccExpiryInput.addEventListener('input', ccExpiryInputInputHandler);

    ccCVCInput = document.getElementById('card-cvv');
    ccCVCInput.addEventListener('input', ccCVCInputHandler);

    payButton = document.getElementById('pay-button');
    payButton.addEventListener('click', executePayment);

    Conekta.setPublicKey('key_ZLmw6aesucnhnVWizqXkjXQ'); //production
    //Conekta.setPublicKey('key_LeEMXYPrS3ezGr1bJFTWKuQ'); //testing
}